import PropTypes from 'prop-types';
import uniqid from 'uniqid';
import { useGlobals } from '@bwoty-web/ui-kit/hooks';
import SectionParagraph from '../../../../common/sectionParagraph';
import './accommodationContent.scss';
import RoomTypeList from './roomTypeList';

const AccommodationContent = ({
  nonConceptAccommodation,
  siteSettings,
  labels,
  toggleRoomInfo,
  accommodationSection,
}) => {
  const { generalTexts, allRoomsUspLists, roomTypes } = nonConceptAccommodation;
  const { isMixedHotel } = useGlobals();
  return (
    <div>
      {generalTexts
        .filter((t) => t.id !== 'optionalTextCleaningDays')
        .map((paragraph) => {
          return (
            <SectionParagraph paragraph={paragraph} key={uniqid('paragraph')} />
          );
        })}
      <RoomTypeList
        roomTypes={roomTypes}
        siteSettings={siteSettings}
        labels={labels}
        toggleRoomInfo={toggleRoomInfo}
        accommodationSection={accommodationSection}
      />
      {allRoomsUspLists.map((paragraph) => {
        return (
          <SectionParagraph paragraph={paragraph} key={uniqid('usp-list')} />
        );
      })}
      {generalTexts
        .filter((t) => t.id === 'optionalTextCleaningDays')
        .map((paragraph) => {
          return (
            <SectionParagraph paragraph={paragraph} key={uniqid('paragraph')} />
          );
        })}
      {isMixedHotel && <p>{labels.additionalRoomTypes}</p>}
    </div>
  );
};

AccommodationContent.propTypes = {
  nonConceptAccommodation: PropTypes.shape({
    generalTexts: PropTypes.arrayOf(PropTypes.shape({})),
    allRoomsUspLists: PropTypes.arrayOf(PropTypes.shape({})),
    roomTypes: PropTypes.arrayOf(PropTypes.shape({})),
  }).isRequired,
  siteSettings: PropTypes.shape({}).isRequired,
  labels: PropTypes.shape({
    additionalRoomTypes: PropTypes.string,
  }).isRequired,
  toggleRoomInfo: PropTypes.func.isRequired,
  accommodationSection: PropTypes.shape().isRequired,
};

export default AccommodationContent;
